import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_reportes ? (
      <div className="container">
          <Row>
            </Row>
            <br />
            <Row>
            <Col md={4} align="center">
            {user.menu_reportes ?(
              <Button
                href="/MenuReportesVentas"
                className="botonesMenu"
                color="success"
              >
                <i className="fas fa-chart-line fa-7x"></i>
                <br />
                <br />
                Reportes Ventas
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i className="fas fa-chart-line fa-7x"></i>
            <br />
            <br />
            Reportes Ventas
          </Button> }
            </Col>

            <Col md={4} align="center">
            {user.menu_reportes ?(
              <Button
              href="/MenuReportesAdmin"
                className="botonesMenu"
                color="success"
              >
                <i className="fas fa-dollar-sign fa-7x"></i>
                <br />
                <br />
                Reportes Admin
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i className="fas fa-dollar-sign fa-7x"></i>
            <br />
            <br />
            Reportes Admin
          </Button> }
            </Col>
            <Col md={4} align="center">
            {user.menu_reportes ?(
              <Button
              href="/Dashboards"
                className="botonesMenu"
                color="success"
              >
                <i className="fas fa-chart-bar fa-7x"></i>
                <br />
                <br />
                Dashboards
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i className="fas fa-chart-bar fa-7x"></i>
            <br />
            <br />
            Dashboards
          </Button> }
            </Col>
            </Row>
            <br />
            <Row>
            <Col md={4} align="center">
            {user.menu_reportes ?(
              <Button
              href="/MenuReportesV2"
                className="botonesMenu"
                color="success"
              >
                <i className="fas fa-chart-bar fa-7x"></i>
                <br />
                <br />
                Reportes V2
              </Button>
            ): <Button
            disabled
            className="botonesMenu"
            color="success"
          >
            <i className="fas fa-chart-bar fa-7x"></i>
            <br />
            <br />
            Reportes V2
          </Button> }
            </Col>
            </Row>
            <br />
      </div>
      ) : undefined}
    </>
  );
}

export default BotonesReportes;
